function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "none"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_27",
  "data-name": "Group 27",
  transform: "translate(-621 -130)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10",
  transform: "translate(493 29)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  transform: "translate(128 101)",
  fill: "#fff",
  stroke: "#5485bb",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 17,
  rx: 18,
  ry: 17,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 18,
  cy: 17,
  rx: 17.5,
  ry: 16.5,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Options",
  transform: "translate(631 139)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_449",
  "data-name": "Rectangle 449",
  width: 16,
  height: 16,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_1",
  "data-name": "Union 1",
  d: "M0,13.5A1.5,1.5,0,1,1,1.5,15,1.5,1.5,0,0,1,0,13.5Zm0-6A1.5,1.5,0,1,1,1.5,9,1.5,1.5,0,0,1,0,7.5Zm0-6A1.5,1.5,0,1,1,1.5,3,1.5,1.5,0,0,1,0,1.5Z",
  transform: "translate(7 1)",
  fill: "#2699fb"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 36,
  height: 34,
  viewBox: "0 0 36 34"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/options-dots.7bb5acc6.svg";
export { SvgComponent as ReactComponent };